import { Breadcrumb as BreadcrumbBase, BreadcrumbProps } from 'antd';

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  className,
  ...props
}) => {
  return <BreadcrumbBase className={className} {...props} />;
};
